/**
 * Atomic Button component
 * Self-contained, no external dependencies
 */
import React from 'react';
import './Button.css';

export const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', // 'primary' | 'secondary' | 'outline' | 'text'
  disabled = false,
  loading = false,
  size = 'medium', // 'small' | 'medium' | 'large'
  fullWidth = false,
  type = 'button'
}) => {
  return (
    <button
      type={type}
      className={`gwe-button gwe-button--${variant} gwe-button--${size} ${fullWidth ? 'gwe-button--full' : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading && <span className="gwe-button__spinner" />}
      {children}
    </button>
  );
};
